module.exports = __webpack_public_path__ + "static/media/Logical_Decisions.f2e7f2b1.jpg";